import { compose, lifecycle } from 'recompose'

import { setWrapDisplayName } from 'hoc/setWrapDisplayName'

export const withComponentDidMount = componentDidMountFn => BaseComponent =>
  compose(
    setWrapDisplayName(BaseComponent, 'withComponentDidMount'),
    lifecycle({
      componentDidMount() {
        componentDidMountFn(this.props)
      },
    }),
  )(BaseComponent)
